/**
 * Aplica a largura salva pelo usuário (vinda de `/ColunasTabela/ObterConfiguracoesColunasTabela`)
 * na coluna `allColumns[index]` e devolve a coluna resultante.
 *
 * IMPORTANTE: `allColumns` normalmente contém, para as colunas declaradas via <ListColumn>
 * no JSX, o próprio `.props` do elemento React — e o React congela (`Object.freeze`) esse
 * objeto em desenvolvimento. Por isso NÃO mutamos `allColumns[index]` diretamente (isso
 * lançaria TypeError em dev, já que módulos ES são sempre strict mode); em vez disso
 * substituímos a entrada do array por um clone. Quem chama deve usar o valor retornado
 * (e não uma referência antiga) para manter a identidade entre `allColumns[index]` e as
 * demais listas de colunas do render.
 *
 * `widthPersisted` marca a coluna como redimensionada/persistida, habilitando o "pin" de
 * minWidth/maxWidth no <th>, sem afetar colunas que já usam um `width` estático
 * declarado no JSX.
 */
export function applySavedWidth(allColumns, index, savedColumn) {
  if (savedColumn && savedColumn.width) {
    allColumns[index] = {
      ...allColumns[index],
      width: savedColumn.width,
      widthPersisted: true,
    };
  }

  return allColumns[index];
}

/**
 * Aplica, em `allColumns`, a largura salva de cada coluna e empurra as colunas
 * correspondentes para `columns`, na ordem em que vieram salvas. Devolve `columns`.
 */
export default function applySavedColumnConfig(allColumns, columns, savedColumns) {
  (savedColumns || []).forEach((coluna) => {
    const index = allColumns.findIndex((c) => c.valueField === coluna.valueField);
    if (index === -1) return;

    columns.push(applySavedWidth(allColumns, index, coluna));
  });

  return columns;
}
